export const STORAGE_KEY = 'current_assessment_type';

class AssessmentTypeStorage {
    constructor(storage, key) {
        this.storage = storage;
        this.key = key;
    }

    #get() {
        const rawData = this.storage.getItem(this.key);
        return rawData ? JSON.parse(rawData) : {};
    }

    // lint treats hashed names as empty and complains if there are more than one
    // eslint-disable-next-line no-dupe-class-members
    #set(value) {
        this.storage.setItem(this.key, JSON.stringify(value));
    }

    read(type) {
        const storedValue = this.#get();
        return storedValue?.[type];
    }

    update(type, value) {
        const storedValue = this.#get();
        const updatedValue = { ...storedValue, [type]: value };
        this.#set(updatedValue);
    }

    clear() {
        this.storage.removeItem(this.key);
    }
}
export default new AssessmentTypeStorage(sessionStorage, STORAGE_KEY);
